import { BookOpen, Gem, HardHat, Pickaxe, GraduationCap, Trophy } from "lucide-react";
import { ACHIEVEMENTS } from "@/data/achievements";
import type { PublicPlatformStats } from "@/lib/publicPlatformStats";

interface StatsBarProps {
  stats?: PublicPlatformStats;
}

function countOrFallback(count: number | undefined, fallback: string) {
  return count === undefined ? fallback : count.toLocaleString("en-CA");
}

export function StatsBar({ stats }: StatsBarProps) {
  const proofPoints = [
    { icon: GraduationCap, value: countOrFallback(stats?.training_tracks, "Free"), label: "Training Tracks" },
    { icon: BookOpen, value: countOrFallback(stats?.free_lessons, "Guided"), label: "Geology Lessons" },
    { icon: Gem, value: countOrFallback(stats?.reference_guides, "Sourced"), label: "Reference Items" },
    { icon: HardHat, value: countOrFallback(stats?.career_profiles, "Practical"), label: "Career Profiles" },
    { icon: Pickaxe, value: "Free", label: "Field Workflows" },
    { icon: Trophy, value: ACHIEVEMENTS.length.toLocaleString("en-CA"), label: "Achievements" },
  ];

  return (
    <section className="border-b bg-card">
      <div className="container py-6 md:py-8">
        <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8">
          {proofPoints.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center text-center gap-1 animate-in fade-in slide-in-from-bottom-1 duration-300"
            >
              <stat.icon className="h-5 w-5 text-accent mb-1" />
              <span className="text-2xl md:text-3xl font-display font-bold text-foreground">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-muted-foreground">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
